// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Page from 'app/containers/parts/Page';
import t from 'app/utils/translate';
import { startLiveChallengesPoll, stopLiveChallengesPoll } from 'app/actions/liveChallengesActions';
import { setLobbySport, setLobbySubCategory } from 'app/actions/lobbyActions';
import {
  startMyLiveChallengesPoll,
  stopMyLiveChallengesPoll,
} from 'app/actions/myChallengesActions';
import GroupedChallengesList from 'app/components/challenges/GroupedChallengesList';
import liveChallengesSelector from 'app/selectors/liveChallengesSelector';
import SportsFilterBox from 'app/components/sportsFilters/SportsFilterBox';
import { rewritePath } from '../utils/routeUtils';

type Props = {
  activeSport: ?string,
  activeSubCategory: ?string,
  challengesData: Array<ChallengeData>,
  isFetching: boolean,
  isSignedIn: boolean,
  onSportSelect: (sport: string, subCategory: string) => void,
  onSubCategorySelect: (cat: string) => void,
  onStartChallengesPoll: () => void,
  onStartMyLivePoll: () => void,
  onStopChallengesPoll: () => void,
  onStopMyLivePoll: () => void,
  rewriteRules: Object,
};

class LiveChallenges extends Component<Props> {
  props: Props;

  componentDidMount() {
    this.props.onStartChallengesPoll();
    if (this.props.isSignedIn) {
      this.props.onStartMyLivePoll();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.isSignedIn && !this.props.isSignedIn) {
      this.props.onStartMyLivePoll();
    } else if (this.props.isSignedIn && !nextProps.isSignedIn) {
      this.props.onStopMyLivePoll();
    }
  }

  componentWillUnmount() {
    this.props.onStopChallengesPoll();
    this.props.onStopMyLivePoll();
  }

  render() {
    const {
      activeSport,
      activeSubCategory,
      challengesData,
      isFetching,
      onSportSelect,
      onSubCategorySelect,
      rewriteRules,
    } = this.props;

    return (
      <Page title={t('Live Challenges')}>
        <Helmet title={t('Live Challenges')} />
        <SportsFilterBox
          activeSport={activeSport}
          activeSubCategory={activeSubCategory}
          namespace={rewritePath(rewriteRules)('/live-challenges')}
          onSportSelect={onSportSelect}
          onSubCategorySelect={onSubCategorySelect}
          showAll
          showSubCategories
        />
        <GroupedChallengesList challengesData={challengesData} isFetching={isFetching} inline />
      </Page>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    activeSport: state.lobbyChallenges.activeSport,
    activeSubCategory: state.lobbyChallenges.activeSubCategory,
    challengesData: liveChallengesSelector(state),
    isFetching: state.liveChallenges.isFetching,
    isSignedIn: state.user.isSignedIn,
    rewriteRules: state.settings.rewriteRules,
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return {
    onSportSelect(sport: string, subCategory: string) {
      dispatch(setLobbySport(sport, subCategory));
    },
    onSubCategorySelect(cat: string) {
      dispatch(setLobbySubCategory(cat));
    },
    onStartChallengesPoll() {
      dispatch(startLiveChallengesPoll(true));
    },
    onStopChallengesPoll() {
      dispatch(stopLiveChallengesPoll());
    },
    onStartMyLivePoll() {
      dispatch(startMyLiveChallengesPoll(true));
    },
    onStopMyLivePoll() {
      dispatch(stopMyLiveChallengesPoll());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveChallenges);
